import { awsAuthChallengeTypes } from "../../../consts";

const COGNITO_HOSTED_UI = process.env.REACT_APP_COGNITO_HOSTED_UI;
const COGNITO_HOSTED_UI_CLIENT_ID = process.env.REACT_APP_COGNITO_HOSTED_UI_CLIENT_ID;
const WEB_CLIENT_URL = window.location.origin;

const userPoolWebClientId =
  COGNITO_HOSTED_UI_CLIENT_ID ?? process.env.REACT_APP_AWS_COGNITO_USER_POOLS_WEB_CLIENT_ID;

let awsConfig = {
  Auth: {
    // identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    region: process.env.REACT_APP_AWS_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOLS_ID,
    // userPoolWebClientId: process.env.REACT_APP_AWS_COGNITO_USER_POOLS_WEB_CLIENT_ID,
    userPoolWebClientId,
    authenticationFlowType: awsAuthChallengeTypes.USER_PASSWORD_AUTH
  },
  Storage: {
    bucket: process.env.REACT_APP_AWS_COGNITO_BUCKET_NAME,
    region: process.env.REACT_APP_AWS_COGNITO_REGION
    // identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID
  }
};

const oauth = {
  domain: COGNITO_HOSTED_UI,
  scope: ["email", "openid", "profile"],
  redirectSignIn: `${WEB_CLIENT_URL}/parseauth`,
  redirectSignOut: `${WEB_CLIENT_URL}/`,
  responseType: "code"
};

if (COGNITO_HOSTED_UI) {
  awsConfig = { ...awsConfig, Auth: { ...awsConfig.Auth, oauth } };
}

export default awsConfig;
